import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { UserPayload } from '../models/user-payload';

export const UserEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[user] Edit'),
  requestFail: uniqueActionType('[user] Edit fail'),
  requestSuccess: uniqueActionType('[user] Edit success'),
  requestClearErrors: uniqueActionType('[user] Edit clear errors'),
  requestClear: uniqueActionType('[user] Edit clear')
};

export class UserEditAction implements PayloadAction {
  readonly type = UserEditActionTypes.request;

  constructor(public payload: SendByIdPayload<UserPayload>) {
  }
}

export class UserEditFailAction implements PayloadAction {
  readonly type = UserEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class UserEditSuccessAction implements PayloadAction {
  readonly type = UserEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class UserEditClearErrorsAction implements PayloadAction {
  readonly type = UserEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class UserEditClearAction implements PayloadAction {
  readonly type = UserEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
